import { BOM_WAREHOUSES_REQUIRED_MESSAGE } from './bom-warehouses-required-message.js';
export function checkBomDescription(values) {
    if (!values.description.trim()) {
        return [{ path: 'description', message: 'Description is required.' }];
    }
    return [];
}
export function checkBomIdentityRequiredOnCreate(values) {
    const issues = [];
    if (!values.num.trim()) {
        issues.push({ path: 'num', message: 'BOM name is required.' });
    }
    issues.push(...checkBomDescription(values));
    if (!values.brandId.trim()) {
        issues.push({ path: 'brandId', message: 'Brand is required.' });
    }
    return issues;
}
export function checkBomWarehousesRequiredOnCreate(values) {
    if (values.warehouseLocationGroupIds.length === 0) {
        return [{ path: 'warehouseLocationGroupIds', message: BOM_WAREHOUSES_REQUIRED_MESSAGE }];
    }
    return [];
}
//# sourceMappingURL=rules.js.map